import { type HTMLAttributes, type JSX } from 'react';

import { BottomFixedRoot } from './BottomFixedRoot';
import { BottomFixedBody } from './components/BottomFixedBody';
import { BottomFixedFooter } from './components/BottomFixedFooter';
import { BottomFixedHeader } from './components/BottomFixedHeader';

type BottomFixedComponent = {
  (props: HTMLAttributes<HTMLDivElement> & { hasFooter?: boolean }): JSX.Element;
  Header: typeof BottomFixedHeader;
  Body: typeof BottomFixedBody;
  Footer: typeof BottomFixedFooter;
};

const BottomFixed = BottomFixedRoot as unknown as BottomFixedComponent;
BottomFixed.Header = BottomFixedHeader;
BottomFixed.Body = BottomFixedBody;
BottomFixed.Footer = BottomFixedFooter;

export { BottomFixed };
